import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import { X } from 'lucide-react';
import * as React from 'react';
import { Button } from '@verclam/ui-kit';

const chipStyle = css`
	display: inline-flex;
	align-items: center;
	gap: 0.375rem;
	padding: 0.25rem 0.375rem 0.25rem 0.75rem;
	border-radius: ${theme.radii.pill};
	background-color: ${theme.colors.surfaceMuted};
	color: ${theme.colors.ink};
	font-family: ${theme.fonts.body};
	font-size: ${theme.fontSizes.medium};
`;

type Props = {
	readonly domain: string;
	readonly onRemove: (domain: string) => void;
};

/**
 * One removable domain, own callback so the parent list only carries a single stable `onRemove`
 * reference instead of one inline arrow per rendered chip.
 */
const DomainChip: React.FC<Props> = ({ domain, onRemove }) => {
	const handleRemove = React.useCallback(() => {
		onRemove(domain);
	}, [domain, onRemove]);

	return (
		<span css={chipStyle}>
			{domain}
			<Button
				type="button"
				text
				size="sm"
				icon={<X size={14} />}
				aria-label={`Retirer le domaine ${domain}`}
				onClick={handleRemove}
			/>
		</span>
	);
};

export default DomainChip;
